import { Text } from '@chakra-ui/react';

import { CONTACT_EMAIL } from '~/constants';

import Link from '../Link';

export const ContactError: React.FC = () => (
  <Text>
    Please try again in a few minutes. If the issue persists,{' '}
    <Link
      textDecoration="underline"
      fontWeight="500"
      color="black"
      href={`mailto:${CONTACT_EMAIL}`}
    >
      contact us
    </Link>
    .
  </Text>
);
